import React from 'react';
import { Lock } from 'lucide-react';

export default function ReadOnlyNotice({ children = 'Unlock admin to make changes.' }) {
  return (
    <div className="flex items-center gap-2 rounded-md border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-600">
      <Lock className="h-4 w-4 shrink-0" />
      {children}
    </div>
  );
}
